const DISMISS_KEY = 'kd_push_prompt_dismissed_until';
const DISMISS_HOURS = 24;

export function getWebNotificationPermission() {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'unsupported';
    }
    return Notification.permission;
}

export function isPushPromptDismissed() {
    try {
        const until = Number(sessionStorage.getItem(DISMISS_KEY) || 0);
        return until > Date.now();
    } catch {
        return false;
    }
}

export function dismissPushPromptForLater() {
    try {
        sessionStorage.setItem(
            DISMISS_KEY,
            String(Date.now() + DISMISS_HOURS * 60 * 60 * 1000),
        );
    } catch {
        /* ignore */
    }
}

export function clearPushPromptDismiss() {
    try {
        sessionStorage.removeItem(DISMISS_KEY);
    } catch {
        /* ignore */
    }
}

export async function fetchServerPushStatus(permission) {
    const loginToken = localStorage.getItem('ACT');
    if (!loginToken) {
        return null;
    }
    const { default: axios } = await import('axios');
    const { defaultVariables } = await import('./index');
    const res = await axios.get(`${defaultVariables.url}/firebase/push-status`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,
        },
        params: {
            platform: 'web',
            permission,
        },
    });
    return res.data;
}

export function shouldShowPushPrompt(isAuth, permission, serverStatus) {
    if (!isAuth) {
        return false;
    }
    if (isPushPromptDismissed()) {
        return false;
    }
    if (permission === 'unsupported') {
        return false;
    }
    if (permission === 'denied') {
        return true;
    }
    if (serverStatus && !serverStatus.push_ready) {
        return true;
    }
    if (permission === 'default') {
        return true;
    }
    return false;
}
